// extracted by css-extract-rspack-plugin
export default {"dot":"_3421ecf4","activeDot":"_a6c5faf8"};